const auth_en = {
  title: 'Log in to the account',
  subtitle: 'Please enter your email and password to continue.',
  login: 'Login',
  form: {
    emailAddress: 'Email Address',
    emailAddressPlaceholder: 'Enter your email address',
    emailAddressInvalid: 'Please enter a valid email address',
    emailAddressRequired: 'Email address is required',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    passwordInvalid: 'Please enter a valid password',
    passwordRequired: 'Password is required',
    submit: 'Login',
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset now',
  },
  validation: {
    emailAddress: {
      invalid: 'Please enter a valid email address',
      required: 'Email address is required',
      min: 'Email address must be at least 3 characters',
      max: 'Email address must be at most 255 characters',
    },
    password: {
      invalid: 'Please enter a valid password',
      required: 'Password is required',
      min: 'Password must be at least 3 characters',
      max: 'Password must be at most 24 characters',
      lowercase: 'Password must have a lowercase letter',
    },
  },
  messages: {
    formInvalid: 'Form is invalid.',
    loginSuccessful: 'Login successful.',
    loginFailed: 'Login failed. Please check your credentials.',
    accessDenied: 'Access denied. This portal is for customers only.',
  },
  forgot: {
    title: 'Forgot Your Password',
    subtitle: 'Please enter your email.',
    emailAddress: 'Email Address',
    send: 'Send',
    message: 'Email sent to your mail address'
  },
  sent: {
    title: 'Email Sent',
    subtitle: 'We’ve sent instructions on how to reset your password to',
    ok: 'OK'
  },
  reset: {
    title: 'Reset Password',
    subtitle: 'Please enter your new password.',
    newPassword: 'New Password',
    warningMessagesOne: 'At least 8 characters.',
    warningMessagesTwo: 'At least one uppercase letter, and one number.',
    warningMessagesThree: 'No spaces permitted.',
    confirmNewPassword: 'Confirm New Password',
    reset: 'Reset',
    passwordNotStrong: 'Your password is not strong enough.',
    passwordNotMatch: 'Your passwords do not match.',
    message: 'Password reset was successed',
    failed: 'The password could not be saved. Please try again.',
    link: {
      checking: 'Checking your link…',
      requestNewLink: 'Request a new link',
      backToLogin: 'Back to login',
      expired: {
        title: 'Link expired',
        text: 'This link has expired – password links are valid for 48 hours. Simply request a new one.',
      },
      invalid: {
        title: 'Link no longer valid',
        text: 'This link has already been used or was replaced by a newer email. Use the link from the latest email or request a new one.',
      },
      inactive: {
        title: 'Account not active',
        text: 'Your account is currently not active. Please contact LA CONCEPT.',
      },
    },
    validation: {
      password: {
        notEnough: 'Your password is not strong enough.',
        invalid: 'Please enter a valid password',
        required: 'Password is required',
        min: 'Password must be at least 8 characters',
        lowercase: 'Password must have a lowercase letter',
        uppercase: 'Password must have a uppercase letter',
        number: 'Password must have a number',
        noSpace: 'Space is not allow',
        notMatch: 'Your passwords do not match.'
      },
    },
  },
  changed: {
    title: 'Password Changed',
    subtitle: 'Your password has been successfully changed.',
    backToLogin: 'Back to Login'
  },
  changePassword: {
    menu: 'Change password',
    title: 'Change password',
    confirm: 'We will send a link to change your password to {email}.',
    send: 'Send link',
    cancel: 'Cancel',
    close: 'Close',
    sent: 'We have sent an email to {email}. Use the link in it to set a new password. You stay logged in until then.',
  },
}

export default auth_en
